/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FaxDocument } from './FaxDocument';
import {
    FaxDocumentFromJSON,
    FaxDocumentFromJSONTyped,
    FaxDocumentToJSON,
    FaxDocumentToJSONTyped,
} from './FaxDocument';

/**
 * 
 * @export
 * @interface FaxesFindAllResponse
 */
export interface FaxesFindAllResponse {
    /**
     * 
     */
    data: Array<FaxDocument>;
    /**
     * Total number of fax documents available across all pages
     */
    total: number;
    /**
     * Which page the repsonse represents
     */
    page: number;
    /**
     * Maximum number of faxes per page
     */
    limit: number;
    /**
     * Whether or not there is a next page
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FaxesFindAllResponse interface.
 */
export function instanceOfFaxesFindAllResponse(value: object): value is FaxesFindAllResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function FaxesFindAllResponseFromJSON(json: any): FaxesFindAllResponse {
    return FaxesFindAllResponseFromJSONTyped(json, false);
}

export function FaxesFindAllResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxesFindAllResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(FaxDocumentFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FaxesFindAllResponseToJSON(json: any): FaxesFindAllResponse {
    return FaxesFindAllResponseToJSONTyped(json, false);
}

export function FaxesFindAllResponseToJSONTyped(value?: FaxesFindAllResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(FaxDocumentToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
    };
}

